import { scenario } from './givenWhenThen.ts';
import mergeInto from './mergeInto.ts';

export { mergeInto, scenario };
